import { DecimalPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { PronunciationWordDetail } from '../word-breakdown';

let nextInstanceId = 0;

/**
 * The detail of a word of the pronunciation feedback. It is shown inline, below the sentence,
 * because the voice question is already a dialog and another one on top would not look right.
 */
@Component({
  selector: 'nr-pronunciation-word-detail',
  imports: [DecimalPipe, NgClass, TranslatePipe],
  templateUrl: './pronunciation-word-detail.html',
  styleUrl: './pronunciation-word-detail.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PronunciationWordDetailComponent {
  readonly detail = input.required<PronunciationWordDetail>();

  readonly playing = input<boolean>(false);

  readonly listen = output();

  readonly dismiss = output();

  readonly headingId = `pronunciation-word-detail-${nextInstanceId}`;

  readonly closeId = `pronunciation-word-detail-close-${nextInstanceId++}`;
}
